/* imgsizer (flexible images for fluid sites) — legacy IE helper, no jQuery */
var imgSizer = {
  Config: { imgCache: [], spacer: '/path/to/your/spacer.gif' },
  collate: function (aScope) {
    var isOldIE = document.all && !window.opera && !window.XDomainRequest ? 1 : 0;
    if (isOldIE && document.getElementsByTagName) {
      var c = imgSizer;
      var imgCache = c.Config.imgCache;
      var images = aScope && aScope.length ? aScope : document.getElementsByTagName('img');
      for (var i = 0; i < images.length; i++) {
        images[i].origWidth = images[i].offsetWidth;
        images[i].origHeight = images[i].offsetHeight;
        imgCache.push(images[i]);
        c.ieAlpha(images[i]);
        images[i].style.width = '100%';
      }
      if (imgCache.length) {
        c.resize(function () {
          for (var j = 0; j < imgCache.length; j++) {
            var ratio = imgCache[j].offsetWidth / imgCache[j].origWidth;
            imgCache[j].style.height = imgCache[j].origHeight * ratio + 'px';
          }
        });
      }
    }
  },
  ieAlpha: function (img) {
    var c = imgSizer;
    if (img.oldSrc) {
      img.src = img.oldSrc;
    }
    var src = img.src;
    img.style.width = img.offsetWidth + 'px';
    img.style.height = img.offsetHeight + 'px';
    img.style.filter =
      "progid:DXImageTransform.Microsoft.AlphaImageLoader(src='" + src + "', sizingMethod='scale')";
    img.oldSrc = src;
    img.src = c.Config.spacer;
  },
  resize: function (func) {
    var oldonresize = window.onresize;
    if (typeof window.onresize != 'function') {
      window.onresize = func;
    } else {
      window.onresize = function () {
        if (oldonresize) {
          oldonresize();
        }
        func();
      };
    }
  },
};

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('form').forEach(function (form) {
    if (!form.querySelector('[placeholder]')) {
      return;
    }
    form.addEventListener('submit', function () {
      form.querySelectorAll('[placeholder]').forEach(function (input) {
        if (input.value === input.getAttribute('placeholder')) {
          input.value = '';
        }
      });
    });
  });

  var toggle = document.querySelector('.gt-nav__toggle');
  var menu = document.getElementById('gt-nav-header');
  if (toggle && menu) {
    var labelOpen = toggle.getAttribute('data-label-open') || 'Open menu';
    var labelClose = toggle.getAttribute('data-label-close') || 'Close menu';
    var desktopMq = window.matchMedia('(min-width: 992px)');

    function isMenuOpen() {
      return menu.classList.contains('is-open');
    }

    function getFocusable() {
      var inMenu = Array.prototype.slice.call(
        menu.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')
      );
      return [toggle].concat(inMenu).filter(function (el) {
        return el && !el.hasAttribute('disabled') && el.getAttribute('aria-hidden') !== 'true';
      });
    }

    function setMenuOpen(open) {
      menu.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? labelClose : labelOpen);

      if (open) {
        var firstLink = menu.querySelector('a[href], button:not([disabled])');
        if (firstLink) {
          firstLink.focus();
        }
      }
    }

    function closeMenu(options) {
      if (!isMenuOpen()) {
        return;
      }
      setMenuOpen(false);
      if (options && options.restoreFocus) {
        toggle.focus();
      }
    }

    toggle.addEventListener('click', function () {
      setMenuOpen(!isMenuOpen());
    });

    document.addEventListener('keydown', function (event) {
      if (!isMenuOpen()) {
        return;
      }

      if (event.key === 'Escape') {
        closeMenu({ restoreFocus: true });
        return;
      }

      if (event.key !== 'Tab') {
        return;
      }

      var focusable = getFocusable();
      if (!focusable.length) {
        return;
      }

      var first = focusable[0];
      var last = focusable[focusable.length - 1];
      var active = document.activeElement;

      if (event.shiftKey) {
        if (active === first || !menu.contains(active) && active !== toggle) {
          event.preventDefault();
          last.focus();
        }
      } else if (active === last) {
        event.preventDefault();
        first.focus();
      }
    });

    document.addEventListener('click', function (event) {
      if (!isMenuOpen()) {
        return;
      }
      if (menu.contains(event.target) || toggle.contains(event.target)) {
        return;
      }
      closeMenu();
    });

    var onDesktopChange = function (event) {
      if (event.matches) {
        closeMenu();
      }
    };
    if (typeof desktopMq.addEventListener === 'function') {
      desktopMq.addEventListener('change', onDesktopChange);
    } else if (typeof desktopMq.addListener === 'function') {
      desktopMq.addListener(onDesktopChange);
    }
  }

  document.querySelectorAll('.post_content .panel-group').forEach(function (group) {
    var lastRelocated = new Map();
    var misnested = Array.prototype.slice.call(group.querySelectorAll('.panel .panel'));
    misnested.forEach(function (panel) {
      var outer = panel.parentElement.closest('.panel');
      if (!outer) {
        return;
      }
      var cursor = lastRelocated.get(outer) || outer;
      cursor.parentNode.insertBefore(panel, cursor.nextSibling);
      lastRelocated.set(outer, panel);
    });
  });

  document.querySelectorAll('.post_content [data-toggle="collapse"]').forEach(function (trigger) {
    var targetId = (trigger.getAttribute('href') || '').replace(/^#/, '');
    var target = targetId && document.getElementById(targetId);
    if (!target) {
      return;
    }

    trigger.setAttribute('aria-expanded', 'false');

    trigger.addEventListener('click', function (event) {
      event.preventDefault();

      var willOpen = !target.classList.contains('is-open');
      var parentSelector = trigger.getAttribute('data-parent');
      var group = parentSelector && document.querySelector(parentSelector);

      if (willOpen && group) {
        group.querySelectorAll('.panel-collapse.is-open').forEach(function (openPanel) {
          if (openPanel === target) {
            return;
          }
          openPanel.classList.remove('is-open');
          var openTrigger = group.querySelector('[data-toggle="collapse"][href="#' + openPanel.id + '"]');
          if (openTrigger) {
            openTrigger.classList.add('collapsed');
            openTrigger.setAttribute('aria-expanded', 'false');
          }
        });
      }

      target.classList.toggle('is-open', willOpen);
      trigger.classList.toggle('collapsed', !willOpen);
      trigger.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    });
  });
});
